import { ITripLeg } from '~/api/ITripLeg';

export const findLeg = (legs: ITripLeg[], legType: string) => (Array.isArray(legs)
  ? legs.find((leg) => leg.type === legType)
  : undefined);
